import React from 'react';
import PatientPrescriptionSummary from './PatientPrescriptionSummary';
import PatientVisitInformation from './PatientVisitInformation';
import PaymentHistory from './PaymentHistory';
import { FaArrowLeft, FaUserCircle } from 'react-icons/fa';
import './PatientInfoPanel.css';

const PatientInfoPanel = ({ patient, onBack }) => {
  return (
    <div className="patient-info-wrapper">
      <div className="breadcrumbb">
        <div className="breadcrumbb-title">
          Dashboard / <strong>Prescriptions/Prescription</strong>
        </div>
        {/* Dashboard / <strong>New Prescription</strong> */}
        <button onClick={onBack} className="custom-back-button">
          <FaArrowLeft className="icon-left" />
          Back
        </button>
      </div>
      {/* <div className="back-button-container">
        <button onClick={onBack} className="back-button">
          <FaArrowLeft />
          Back
        </button>
      </div> */}

      <div className="patient-info-container">
        <div className="photo-column">
          {patient.photo ? (
            <img
              src={`data:image/jpeg;base64,${patient.photo}`}
              alt="Patient"
              className="patient-photo"
              loading="lazy"
            />
          ) : (
            <img src={'https://static.vecteezy.com/system/resources/thumbnails/055/630/851/small/male-nurse-or-doctor-avatar-icon-wearing-medical-uniform-vector.jpg'} />
          )}
        </div>

        <div className="info-column">
          <h3 className="patient-name">{`${patient.patientName}, ${patient.gender}, ${patient.age}yrs`}</h3>
          <PatientPrescriptionSummary patient={patient} />
        </div>

        <div className="visit-column">
          <div className="visit-buttons">
            <button className="token-btn">🔢123</button>
            {/* <button className="status-btn">✅ Completed</button> */}
            <button className="priority-btn">🚨 Priority</button>
            <button className="label-btn">🏷️ Label</button>
          </div>
          <PatientVisitInformation patient={patient} />
        </div>
      </div>

      <div className="payment-history">
        <PaymentHistory patient={patient} />
      </div>
    </div>
  );
};

export default PatientInfoPanel;
